export const colors = {
	blank: "#ffffff",
	body: "#3f3e3e",
	brandPrimary: "#24245b",
	brandHighlight: "#977b59",
	offColor: "#cecece",
	inactiveColor: "#868686"
}

export const fonts = {
	main: "'Circular Pro', Helvetica, Arial, san serif",
	feature: "'CaslonGraD', Times, serif"
}

export const padding = {
	inner: 3.5,
	outer: 21.5,
	tabInner: 2.5,
	tabOuter: 5,
	mobInner: 1,
	mobOuter: 4
}

export const time = 0.3;


// WEBPACK FOOTER //
// ./src/style/vars.js